module.exports = __webpack_public_path__ + "media/images/wintak_mil_blk_cord-706d4cb15e4636cd2bc233879405a132.png";